import { ConfigProvider, DatePicker, Space } from "antd";
const { RangePicker } = DatePicker;
const PlaybackDate = () => (
  <ConfigProvider
    theme={{
      token: {
        colorPrimary: "#0f6936",
        activeBg: "#0f6936",
        activeBorderColor: "#2e9245",
      },
    }}
  >
    <RangePicker showTime style={{ width: "100%" }} />
  </ConfigProvider>
);
export default PlaybackDate;
